export default [
  {
    period: 'Mar 2019',
    role: 'Full stack Engineer',
    company: {
      name: 'Square Enix',
      url: 'https://www.square-enix-games.com/'
    },
    location: "London, UK",
    description: `<p>Working on different internal projects based on Javascript, on the client side with React, Styled Components, NextJS and on the server side with Node, custom server-side rendering, GraphQL, Docker, Redis and many other tools.</p>
    <p>The main project is a dynamic web site rendered server side and hydrated client side, with the layout and the content fetched real-time based on the website, the page and the locale required.</p>
    <p>All the public projects are particularly focused on the performances and they support an ad hoc implementations of CDNs and Redis cache.</p>`
  },
  {
    period: 'Aug 2018 - Dec 2019',
    role: 'Lead Web App Engineer',
    company: {
      name: 'LOOP Messenger',
      url: 'https://www.loopmessenger.com/'
    },
    location: "Remote (free time)",
    description: `<p>Loop Messenger is a startup company based in the USA with the aim of improving the group chat experience. My contribution to the project is compensated with nominal shares and this allows me to be free to work on it whenever I can, like during the weekend.</p>
    <p>I've created the web app project from the scratch (still in alpha version), setting up all the CI flow with automatic deploys and test checks before each release like e2e, unit and linting, adding analytics tools like LogRocket. The stack includes <strong>React/Redux</strong> with the support of the framework MaterialUI to speed up the development, redux-saga to manage the async part and the side effects.</p>
    <p>Unit tests are running with Jest and the e2e test with <strong>CypressIO</strong>. The hosting is offered by <strong>Netlify</strong> and the CI service by <strong>CircleCI</strong>.</p>
    <p>I report directly to the CEO and I collaborate directly with all the team (BE and mobile).</p>`
  },
  {
    period: 'Sep 2018 - Dec 2018',
    role: 'UI Engineer',
    company: {
      name: 'Massive Interactive',
      url: 'https://massive.co/'
    },
    location: "Remote",
    description: `<p>Massive Interactive is recognised and awarded for powering the world's best multiscreen video platforms and solutions. The tech team is spread across London, Prague and some remote people working from home, with an amazing project management able to keep the remote team synchronized and independent also on different time zones.</p>
    <p>The main product is a white label project, customized for each customer, built on <strong>React/Redux + Typescript and SASS</strong> on the front end.</p>
    <p>I worked on the BritBox project in order to extend the existing subscription process and to give the opportunity to their users to buy an annual plan, use promo codes, buy and redeem gift codes.</p>`
  },
  {
    period: 'Feb 2018 - Aug 2018',
    role: 'Senior JavaScript Engineer',
    company: {
      name: 'Moteefe',
      url: 'https://moteefe.com/'
    },
    location: "Remote",
    description: `<p>Moteefe is a fulfillment company based in London, with a great product and an amazing tech team.
    All the tech team was full remote with people working from Mexico (UTC -6) to Thailand (UTC +7), with useful tools for a good <strong>asynchronous
    communication</strong>.</p>
    <p>The tech stack is based on Ruby On Rails with <strong>multiple React apps</strong> integrated into the same repository. The Front end was based on
    React Redux and <strong>styled components</strong>, while the tests part was based on <strong>Jest for unit tests</strong> and <strong>Cypress for e2e
    tests</strong>.</p>
    <p>Hired for my experience on the <strong>web app architectures</strong>, I planned a <strong>migration</strong> process in order to isolate the web
    apps in separate repositories and to split as well some apps to improve the <strong>scalability</strong>, I've introduced the <strong>BDD
    testing</strong> methodology and moved the team to write more and better tests.</p>
    <p>On the coding part, I developed a new <strong>spin-off project</strong>, reusing some logic from the existing one but with a
    <strong>refactoring</strong> in order to make the code more scalable and reusable.</p>`
  },
  {
    period: "Jun 2017 - Jan 2018",
    role: "Javascript Engineer",
    company: {
      name: "Nutmeg",
      url: "https://www.nutmeg.com/"
    },
    location: "London, UK",
    description: `
      <p>Nutmeg is a pioneer company in the robo-advisory industry and a fast growing <strong>fintech</strong> company. I was hired to start the migration
      of the corporate website to React, starting from scratch, but with a lot of maintenance on the existing project-based part on Ruby on Rails,
      CoffeeScript and jQuery and part on Typescript and AngularJS (1.5). The migration stage was focused on the signup process as it required an urgent
      change to be compliant with the MiFID II and it involved the entire user dashboard as well.</p>
      <p>I was <strong>leading the React migration</strong> and the new signup project, with a team of 3 people, one of them was working remotely.</p>
      <p>The frontend stack was based on <strong>React, Redux, redux-saga</strong> to manage side effects and async actions and <strong>GraphQL</strong>
      for the API interface, while the tests part was based on <strong>Jest for unit tests</strong> and <strong>WebdriverIO for e2e tests</strong>.</p>
    `,
  },
  {
    "period": "Jul 2016 - May 2017",
    "role": "Senior Front End Engineer",
    "company": {
      "name": "Loveholidays",
      "url": "https://www.loveholidays.com/"
    },
    "location": "London, UK",
    "description": `
      <p>Loveholidays is a fast-growing online <strong>travel</strong> company, then acquired by an international big player. I moved from Italy to the UK,
      I found in Loveholidays the right place where I could show all my knowledge and experience on the web and mainly on the <strong>Javascript</strong>
      technologies and at the same time, improving my experience as well.</p>
      <p>As Senior Frontend Engineer I worked on the main product, the corporate website, based on 2 different frameworks: the desktop website on
      Backbone.js and the <strong>mobile website on React</strong>.</p>
      <p>In Loveholidays I've improved a lot my experience in writing unit tests and working on a <strong>high traffic website</strong>.</p>
      <p>The frontend stack was based on React and Backbone.js, writing with the ES6 syntax and <strong>Babel</strong> as the compiler,
      <strong>Webpack</strong> for building tools, using <strong>SASS</strong> and <strong>PostCSS</strong> for the styling, <strong>Mocha, Chai and Sinon
      for unit tests</strong>. The tech team was applying the modern agile methodologies like <strong>Scrum</strong>, then replaced with
      <strong>Kanban</strong>, <strong>Pair Programming</strong>, and <strong>Continuous Integration</strong>, with <strong>Git</strong> and tools like
      <strong>Jira and Confluence</strong>.</p>
    `
  },
  {
    "period": "Aug 2014 - Jun 2016",
    "role": "Technical Leader",
    "company": {
      "name": "Objectway",
      "url": "http://www.objectway.com/"
    },
    "location": "Milano, IT",
    "description": `
      <p>In Objectway I worked on a project that was a large single page application written in <strong>AngularJS</strong> v1.4, using
      <strong>TypeScript</strong>. The project was a white label portfolio management application for European customers, modular and dynamic.</p>
      <p>The web app, built also for mobile devices, required a lot of attention to the <strong>performances and network optimizations</strong>.</p>
      <p>On a side of the SPA, I worked also on two <strong>NodeJS</strong> servers built to support some front-end functionalities, like a
      <strong>WebSockets</strong> server and <strong>D3 charts static renderer</strong> server side.</p>
      <p>In Objectway I had different roles during my time there, I developed the project from scratch and worked after as <strong>architect and R&D
      developer</strong> for new features. I was the team leader of the R&D team while I was also the <strong>project tech leader</strong>. The main tasks
      for the R&D team were: increasing the <strong>app performances</strong>, improving the development experience and finding ways to integrate the
      project with third parties. This last task required also often my presence for <strong>pre-sales</strong> meeting for technical consultancy.</p>
      <p>The front-end stack was built on AngularJS v1.4, with build tools like Grunt, replaced by Gulp, and Yeoman. The project, poor of test coverage,
      was covered by precompiling languages like CoffeeScript at the beginning, replaced by TypeScript then, Pug for HTML and <strong>SASS</strong> for
      CSS. For the unit tests, there was Jasmine with Karma, as version control system Mercurial and Git. The R&D team worked a lot with
      <strong>Websockets</strong> and <strong>WebRTC</strong> (check this
      <a href="https://www.slideshare.net/micheledisalvatore/webrt-socketio-building-a-skypelike-video-chat-with-native-javascript" name="SocketIO and
      WebRTC for an open source skype like chat" target="_blank" rel="noopener noreferrer">slides on slideshare</a> to see more).</p>
      <p>As a tech leader, I was designing and defining the RESTful API, <strong>training</strong> new colleagues, developing of <strong>proof of
      concepts</strong>, monitoring <strong>security</strong> and performance.</p>
    `
  },
  {
    "period": "May 2013 - Mar 2014",
    "role": "Full Stack Developer",
    "company": {
      "name": "Clever Minds LTD"
    },
    "location": "Remote",
    "description": "<p>I was one the 4 founders and I am the only digital expert, I look after organizing the digital marketing strategy and development of front end and back end.</p><p>The platform is written in Ruby on Rails, on MVC paradigm. This is the first time that I realize a personal project using this language and I have engaged in to increase the topic started in my experience at dSmart.</p><p>Thanks to my experience as a blogger and the course in Digital Marketing Specialist, I organize the editorial and digital marketing strategy, using social media and SEO SEM techniques.</p><p>Skills:</p><ul><li>server-side Ruby on Rails: MVC and OO</li><li>client-side Javascript with jQuery</li><li>databases PostgreSQL MySQL sqlite3 MongoDB</li><li>markup language HMTL5 and CSS3 in a responsive theme</li><li>bootstrap Twitter</li><li>API: Mangopay, Facebook login, Twitter login</li><li>versioning system GIT</li><li>hosting on Heroku</li></ul><p>Capabilities:</p><ul><li>management</li><li>strong propensity to problem-solving</li><li>team organization</li></ul><p>Industry:</p><ul><li>Travel</li></ul>"
  },
  {
    "period": "Oct 2012 - Dec 2013",
    "role": "Full Stack Engineer",
    "company": {
      "name": "dSmart",
      "url": "https://www.teamartist.com/"
    },
    "location": "Milano, IT",
    "description": "<p>In dSmart I got my first professional work experience, complete in all perspective, especially regarding the responsibility.</p><p>My role was the management and resolution of the issues and the implementation of new functionality for client websites on Wordpress CMS.</p><p>Skills:</p><ul><li>server-side PHP and Ruby On Rails</li><li>databases MySQL, MongoDB, and sqlite3</li><li>client-side JavaScript language and the jQuery framework</li><li>Markup language HTML5 and CSS3 (with a strong focus on multi-browser compatibility) </li><li>API: Google Analytics, MailUp</li><li>manipulation and automated processing of XML and HMTL documents </li><li>Use of versioning systems like Git</li><li>Advanced use of Unix console</li></ul><p>Capacity:</p><ul><li>Team working</li><li>Responsibility and autonomy in charge of the projects</li><li>Strong propensity to problem-solving</li></ul><p>Activities:</p><ul><li>Performances optimization</li></ul><p>Open Source projects released:</p><ul><li>WordPress plugin to automize subscription to MailUp newsletter via the comments form</li><li>WordPress plugin to manage Robots.txt in WPMU</li><li>PHP class: SEO analyzer spider of the entire website</li></ul><p>Industry:</p><ul><li>No profit</li><li>Sport</li><li>Associations</li></ul>"
  },
  {
    "period": "Apr 2011 - Jul 2011",
    "role": "JavaScript developer",
    "company": {
      "name": "RFId Solution Center Labs - Politectico di Milano"
    },
    "location": "Milano, IT",
    "description": "<p>Feasibility study and integration of a new interface for the presentation of location data generated by the system developed by the Advanced Wi-care Virgilio Network technologies.</p>"
  },
  {
    "period": "Feb 2009 - May 2009",
    "role": "Wordpress developer",
    "company": {
      "name": "Tuttogratis",
      "url": "http://www.tuttogratis.it/"
    },
    "location": "Milano, IT",
    "description": "<p>Web Developer (PHP, MySQL, JavaScript, jQuery, HTML, CSS) on WordPress CMS customization.</p>"
  },
  {
    "period": "Nov 2008 - Jan 2009",
    "role": "Blogger",
    "company": {
      "name": "Tuttogratis",
      "url": "http://www.tuttogratis.it/"
    },
    "location": "Milano, IT",
    "description": "<p>Publishing and writing daily articles themed computer on the NanoPress.it network, part of Tuttogratis Italia SPA</p>"
  },
  {
    "period": "Oct 2007 - Sep 2012",
    "role": "Full Stack Developer",
    "company": {
      "name": "Freelance"
    },
    "location": "Milano, IT",
    "description": ""
  },
  {
    "period": "Oct 2007 - Dec 2011",
    "role": "Founder and Blogger",
    "company": {
      "name": "DylanBlog.com (now offline)"
    },
    "location": "Milano, IT",
    "description": "<p>Founder, owner and editor of a blog theme computer. Developer of custom functions using the following languages: ASP, PHP, Javascript, HTML, CSS and jQuery framework.</p>"
  }
]


// WEBPACK FOOTER //
// ./src/components/Jobs/jobsList.js